// redux/actions/abogados/types.js
export const FETCH_ABOGADOS_SUCCESS = "FETCH_ABOGADOS_SUCCESS";
export const FETCH_ABOGADOS_FAILURE = "FETCH_ABOGADOS_FAILURE";
